$(document).on('click', '.forgot-password', function() {
  $.post($(this).data('url'), () => $('.forgot-password-alert').removeClass('d-none'));
  return false;
});